// extracted by mini-css-extract-plugin
export default {"container":"NoBoard_container__FGGVU","message":"NoBoard_message__H0+sT"};